<ng-container *ngIf="snoozeEnd">
  <p *ngIf="productService.isDateWithinCurrentYear(snoozeEnd)" class="snoozed">
    {{ 'AVAILABLE_IN' | translate:{date: getDateTillSnoozeEnd()} }}
  </p>

  <p *ngIf="!productService.isDateWithinCurrentYear(snoozeEnd)" class="snoozed">
    {{ 'NOT_AVAILABLE_ATM' | translate }}
  </p>
</ng-container>
